$(document).ready(function() {

    $(document).on('click', '.quick-add .quick-add__submit', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const productUrl = $(this).attr('data-product-url');

        if (productUrl) {
            window.location.href = productUrl;
        }
    });
    if ($('.product-info-slider').length) {
        if ($('.product-info-slider').hasClass('slick-initialized')) {
            $('.product-info-slider').slick('unslick');
        }
        $('.product-info-slider').slick({
            arrows: false,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            swipeToSlide: true,
            touchThreshold: 10,
            adaptiveHeight: false
        });
    }

    if ($('.real-repair-slider').length) {
        if ($('.real-repair-slider').hasClass('slick-initialized')) {
            $('.real-repair-slider').slick('unslick');
        }

        $('.real-repair-slider').slick({
            arrows: false,
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            swipeToSlide: true,
            touchThreshold: 10
        });

    }
    if ($('.clinical-slider').length) {
        initClinicalSlider();
    }
    if ($('.community-slider').length) {
        $('.community-slider').slick({
            slidesToShow: 2.6,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
            responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2.2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2.1
                    }
                }
            ]
        });
    }
    $('.community-title').click(function() {
        $(this).parent().toggleClass('active');
        $(this).next().stop().slideToggle();
    });

    // var $beforeSlider = $('.ba-results-slider');
    // if($beforeSlider.length){

    //     if ($beforeSlider.hasClass('slick-initialized')) {
    //         $beforeSlider.slick('unslick');
    //     }

    //     $beforeSlider.slick({
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //         infinite: false,
    //         arrows: false,
    //         dots: true,
    //         adaptiveHeight: false,
    //         speed: 400,
    //         responsive: [{ breakpoint: 992, settings: { slidesToShow: 1, slidesToScroll: 1 } }]
    //     });
    // }


});

function initClinicalSlider() {

    $('.clinical-slider').each(function() {

        if ($(this).hasClass('slick-initialized')) return;

        $(this).slick({
            arrows: false,
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
            swipeToSlide: true
        });

    });

}